// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tr3s","colBig":"styles_colBig__3yAxT","colSmall":"styles_colSmall__2NhbZ","shopifyNameWrapper":"styles_shopifyNameWrapper__3KC5S"};